import { createReducer, on } from "@ngrx/store";
import { initialCourseContentMetadataState } from "./course-content-metadata.state";
import { GetActivityDetails, GetActivityDetailsError, GetActivityDetailsSuccess, GetResourceDetails, GetResourceDetailsError, GetResourceDetailsSuccess } from "./course-content-metadata.actions";

export const CourseContentMetadataReducers = createReducer(
  initialCourseContentMetadataState,
  on(GetActivityDetails, (state) => {
    return {
      ...state,
      activityDetailResult: null,
      loading: true,
      error: null
    }
  }),
  on(GetActivityDetailsSuccess, (state, action) => {
    return {
      ...state,
      activityDetailResult: action.result,
      loading: false
    }
  }),
  on(GetActivityDetailsError, (state, action) => {
    return {
      ...state,
      loading: false,
      error: action.error
    }
  }),
  on(GetResourceDetails, (state) => {
    return {
      ...state,
      resourceDetails: null,
      resourceDetailsLoader: true,
      resourceDetailsError: null
    }
  }),
  on(GetResourceDetailsSuccess, (state, action) => {
    return {
      ...state,
      resourceDetails: action.result,
      resourceDetailsLoader: false,
      resourceDetailsError: null
    }
  }),
  on(GetResourceDetailsError, (state, action) => {
    return {
      ...state,
      resourceDetailsLoader: false,
      resourceDetailsError: action.error
    }
  }),
)